import { MouseEventHandler } from "react";
import clsx from "clsx";
import { MagnetIcon } from "../Icon";

type Props = {
  label: string;
  handleOnClick: MouseEventHandler;
  additionalClasses?: string;
};

// TODO: @JP to rename this component.
function PlaceHolderButton({ label, handleOnClick, additionalClasses = "" }: Props) {
  return (
    <button
      type="button"
      onClick={handleOnClick}
      className={clsx(
        "h-full w-1/3 rounded-lg border-1 border-dashed border-white px-12 py-20 opacity-70 transition-opacity duration-100 hover:opacity-100",
        additionalClasses,
      )}
    >
      <div className="mx-auto w-12 opacity-60">
        <MagnetIcon />
      </div>
      <span className="mt-2 block text-xxs font-medium text-white opacity-70 xl:text-xs 2xl:text-sm">{label}</span>
    </button>
  );
}
export default PlaceHolderButton;
